// extracted by mini-css-extract-plugin
export default {"container":"SUaXz","background":"Js2_y","backgroundColor":"cOLr2","wave":"BOQQW","content":"xZCXg","title":"xEndI","cardContainer":"tXVq2"};